import {
    GET_CAT_VALUE_DETAILS_API_REQUEST,
    GET_CAT_VALUE_DETAILS_API_SUCCESS,
    GET_CAT_VALUE_DETAILS_API_ERROR,
    ADD_CAT_VALUE_DETAILS_API_REQUEST,
    ADD_CAT_VALUE_DETAILS_API_SUCCESS,
    ADD_CAT_VALUE_DETAILS_API_ERROR,
    UPDATE_CAT_VALUE_DETAILS_API_REQUEST,
    UPDATE_CAT_VALUE_DETAILS_API_SUCCESS,
    UPDATE_CAT_VALUE_DETAILS_API_ERROR
} from '../../../constants/dutch/catValueDetailsActionNames';

export const initialState = {
    isLoading: false,
    isSuccess: true,
    isError: false,
    catValues: null,
};

function adminReducer(_state = initialState, action) {
    const state = {
        ..._state,
    };

    switch (action.type) {
        case GET_CAT_VALUE_DETAILS_API_REQUEST:
        case ADD_CAT_VALUE_DETAILS_API_REQUEST:
        case UPDATE_CAT_VALUE_DETAILS_API_REQUEST: {
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false,
            };
        }
        case GET_CAT_VALUE_DETAILS_API_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                isError: false,
                catValues: action.payload,
            };
        }
        case ADD_CAT_VALUE_DETAILS_API_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                isError: false,
                catValues: {
                    ...state.catValues,
                    data: [action.payload, ...state.catValues?.data],
                }
            };
        }
        case UPDATE_CAT_VALUE_DETAILS_API_SUCCESS: {
            const catData = state.catValues
            const oldRecords = catData?.data?.filter(item => item.id != action?.payload?.id)
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                isError: false,
                catValues: {
                    ...state.catValues,
                    data: [action.payload, ...oldRecords],
                }
            };
        }
        case GET_CAT_VALUE_DETAILS_API_ERROR:
        case ADD_CAT_VALUE_DETAILS_API_ERROR:
        case UPDATE_CAT_VALUE_DETAILS_API_ERROR: {
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                isError: true,
            };
        }
        default:
            return state;
    }
}

export default adminReducer;
